module.exports = __webpack_public_path__ + "Flama-ExtraboldItalic.woff?dd9f08ae153df3b3a9bab843d0f345f9";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-ExtraboldItalic.woff
// module id = 900
// module chunks = 0